<template>
  <div class="block-a">
    <div class="block-a__content">
      <div class="block-a__left" v-bind:class="{fixed: hasSticky, 'light': lightDot}">
        <div class="block-a__letter letter letter-red" data-aos="fade-up">
          А.
        </div>
        <div class="block-a__image block-a__image--1" data-aos="fade-up">
          <img src="../assets/img/block-a-1.png" class="tilt"  data-tilt-scale="1.2" alt="">
        </div>
        <div class="block-a__image block-a__image--2 rellax" data-rellax-speed="0.4" data-rellax-percentage="0.4">
          <img src="../assets/img/block-a-2.jpg" alt="">
        </div>
      </div>
      <div class="block-a__right" data-aos="fade-up">
        <div class="block-a__image block-a__image--3">
          <img src="../assets/img/block-a-3.jpg" alt="">
        </div>
        <div class="block-a__title">Александр</div>
        <div class="block-a__text text text-black">Александр Вертинский — певец, киноактёр, композитор, поэт и самый известный русский шансонье ХХ века. Вертинский жил, пел и был популярен в Константинополе, Париже, Ницце, Нью-йорке, Лос-Анжелесе, Харбине, Шанхае и Москве. Его любили прекрасные женщины, ему аплодировали королевские особы и воры. Человек богемы, легкий, весёлый, снисходительный, настоящий «красивый русский».</div>
      </div>
    </div>
  </div>
</template>

<script>
import VanillaTilt from 'vanilla-tilt'
export default {
  name: 'BlockA',
  data() {
    return {
      hasSticky: false,
      lightDot: false,
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted() {
    VanillaTilt.init(document.querySelectorAll(".tilt"));
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll () {
      let fullH = document.documentElement.getBoundingClientRect().height;
      let topH = window.pageYOffset;
      let procentScroll = topH/fullH*100;
      if (window.innerWidth > 1000) {
        if (procentScroll > 21 && procentScroll < 65.4) {
          this.lightDot = true;
        } else {
          this.lightDot = false;
        }
        if (procentScroll > 12 && procentScroll < 86.4 ) {
          this.hasSticky = true;
        } else {
          this.hasSticky = false;
        }
      }
    }
  },
}
</script>

<style lang="sass">
  .block-a
    padding-top: vw(61px)
    margin-bottom: vw(80px)
    @media screen and (max-width: 999px)
      padding-top: vwm(9px)
    &__content
      display: flex
      padding-left: vw(125px)
      @media screen and (max-width: 999px)
        padding-left: vwm(5px)
        flex-direction: column
    &__text
      @media screen and (max-width: 999px)
        font-size: vwm(17px) !important
        line-height: vwm(22px) !important
        width: 86vw
        margin-left: vwm(8px) !important
        margin-top: vwm(52px) !important
    &__image
      img
        width: 100%
      &--1
        width: vw(297px)
        margin-left: vw(287px)
        margin-top: vw(-159px)
        position: relative
        z-index: 10
        @media screen and (max-width: 999px)
          width: vwm(192px)
          height: vwm(232px)
          margin-left: vwm(211px)
      &--2
        width: vw(457px)
        margin-top: vw(-153px)
        position: relative
        @media screen and (max-width: 999px)
          display: none
        &:after
          content: ''
          width: vw(379px)
          height: vw(425px)
          background-size: contain
          background-repeat: no-repeat
          background-image: url(../assets/img/block-a-el.png)
          position: absolute
          right: vw(-98px)
          top: vw(-70px)
      &--3
        width: vw(352px)
        margin-bottom: vw(37px)
        margin-left: vw(58px)
        @media screen and (max-width: 999px)
          width: vwm(309px)
          margin-top: vwm(-182px)
          margin-left: vwm(-37px)
    &__title
      font-size: vw(72px)
      font-family: 'ZnikomitNo25'
      color: #000
      margin-bottom: vw(42px)
      @media screen and (max-width: 999px)
        font-size: vwm(60px)
        margin-left: vwm(8px)
        margin-top: vwm(-3px)
    &__left
      position: relative
      width: 50%
      min-width: 50%
      &:after
        content: ''
        width: vw(2px)
        height: vw(690px)
        background-color: #000
        position: absolute
        top: 0
        right: vw(62px)
        @media screen and (max-width: 999px)
          display: none !important
      &:before
        content: ''
        width: vw(10px)
        height: vw(10px)
        border-radius: 50%
        background-color: #000
        position: absolute
        top: vw(-17px)
        right: vw(58px)
        @media screen and (max-width: 999px)
          display: none !important
      &.light
        &:before
          background-color: #fff
      &.fixed
        &:before
          position: fixed
          top: 0
          bottom: 0
          z-index: 300  
          left: 0
          right: 0
          margin: auto
    &__right
      margin-left: vw(18px)
      margin-top: vw(17px)
      width: 50%
      min-width: 50%
    &__letter
      margin-left: vw(74px)
      padding-left: vw(27px) !important
      @media screen and (max-width: 999px)
        padding-left: vwm(21px) !important
  .letter
    font-size: vw(200px)
    font-family: 'ZnikomitNo25'
    width: vw(232px)
    min-width: vw(232px)
    height: vw(226px)
    padding: vw(9px) 0
    text-align: center
    position: relative
    @media screen and (max-width: 999px)
      width: vwm(175px)
      height: vwm(172px)
      line-height: vwm(166px)
      font-size: vwm(151.6px)
      padding-top: vwm(0px)
      padding-left: vwm(21px)
    &:before
      content: ''
      display: block
      width: vw(78px)
      height: vw(78px)
      position: absolute
      border-bottom: none !important
      border-right: none !important
      top: vw(-8.5px)
      left: vw(-8.5px)
      @media screen and (max-width: 999px)
        top: vwm(-7.5px)
        left: vwm(-7.5px)
        width: vwm(60px)
        height: vwm(60px)
    &:after
      content: ''
      display: block
      width: vw(78px)
      height: vw(78px)
      position: absolute
      border-top: none !important
      border-left: none !important
      bottom: vw(-8.5px)
      right: vw(-8.5px)
      @media screen and (max-width: 999px)
        bottom: vwm(-6.5px)
        right: vwm(-7.5px)
        width: vwm(60px)
        height: vwm(60px)
    &--yellow
      background-color: #E1C99C
      color: #fff
      &:before
        border: 1px solid #E1C99C
      &:after
        border: 1px solid #E1C99C
    &-red
      background-color: #740D0C
      &:before
        border: 1px solid #740D0C
      &:after
        border: 1px solid #740D0C
    &-line
      border: 1px solid #fff
      &:before
        border: 1px solid #fff
      &:after
        border: 1px solid #fff
    &-line-black
      border: 1px solid #000
      &:before
        border: 1px solid #000
      &:after
        border: 1px solid #000
    &-white
      background-color: #fff
      color: #740D0C
      &:before
        border: 1px solid #fff
      &:after
        border: 1px solid #fff
  .text
    font-size: vw(16px)
    line-height: vw(20px)
    font-family: 'Tautz'
    width: vw(457px)
    @media screen and (max-width: 999px)
      font-size: vwm(17px)
      line-height: vwm(22px)
      width: 86vw
      margin-left: vwm(8px)
      margin-top: vwm(52px)
    p
      margin-bottom: vw(18px)
    &-black
      color: #000
    &-white
      color: #fff
</style>
